import { apiClient, v2Client } from '@api/apiClient'
import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useEffect } from 'react'

export const useGetConfig = (code: string | null) => {
  const { enqueueSnackbar } = useSnackbar()

  const query = useQuery({
    enabled: !localStorage.getItem('config'),
    queryKey: ['config', 'getConfig'],
    queryFn: () => (code ? apiClient.get(`/config/${code}`) : v2Client.get('/config')),
    select: (data) => data.data,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    retry: 0,
  })

  useEffect(() => {
    if (query.isSuccess) {
      localStorage.setItem('config', JSON.stringify(query.data))
    }
  }, [query.data])

  useEffect(() => {
    if (query.isError) {
      enqueueSnackbar('Config not found', { variant: 'error' })
    }
  }, [query.isError])

  return query
}
